//pega priority do current location

import { Subscription } from "rxjs";

// Ver com deixar os nomes - no db como estão os nome com nome_id ou nomeID - camelCase?

/* For Firestore data */

export interface InsertionPoint {
  notebook_id: string;
  parent_id: string;
  priority: number;
  location_string: string;
  compacted_location_string: string;
  has_child: boolean;
}

export interface Notebook {
  id?: string;
  text: string;
  has_child: boolean;
  max_children_priority: number;
  lastChangeTime: Date;
  createdAt: Date;
}

export interface Note {
  id?: string;
  has_child: boolean; // calculado dinamicamente eu acho,, nao sei se armazeno no db, dar uma conferida nisso
  parent_id: string;
  notebook_id: string;
  text: string;
  priority: number;
  image_path?: string;
  max_children_priority: number;
  createdAt: Date;
}


/* for local data*/

/**
 * Node for to-do item
 */
 export class TodoItemNode {
  children: TodoItemNode[];
  item: string;

  has_child: boolean;

  id: string;
  parent_id: string;
  notebook_id: string;
  priority: number;
  maxChildrenPriorityNumber: number;
  image_path: string;
  imageDownloadUrl: string | URL;
  file: File;
  fileName: string;
  //filterOut: boolean;
  mm_id: string;

  //only used by not notebook nodes
  parentRef: TodoItemNode;
  notebookRef: TodoItemNode;

  // only used by notebook node
  childrenNotesLoaded: boolean;
  subscribeChildren: Subscription;
  expandadedStack: TodoItemNode[];
  currentExpandedNode: TodoItemNode;
  notesListeningStarted: boolean;
  lastChangeTime: Date;

  createdAt: Date;
}

/** Flat to-do item node with expandable and level information */
//usa só no componente esse aqui
export class TodoItemFlatNode {
  id: string;
  item: string;
  image_path: string;
  level: number;
  expandable: boolean;
  filterOut: boolean;
}
